module.exports = __webpack_public_path__ + "ad42719f26881d74ede371dfe1c7ff80.svg";